import React from "react";
import "./welcome.css";
import { RoundedImage1, RoundedImage2 } from "../../../assets/images";
import { color } from "framer-motion";

const Welcome = () => {
  return (
    <div className="welcome-container" id="home">
      <div className="welcome-background-glow"></div>
      <div className="welcome-content">
        <div className="welcome-badge">
          <span className="badge-dot"></span>
          N'arrêtez jamais d'apprendre
        </div>
        
        <div className="welcome-text">
          <h1>
            Développez vos compétences avec <br />
            <span className="highlight-text">FOK NJE7EK</span>
          </h1>
          <p>
            La plateforme d'excellence en Tunisie spécialisée dans les 
            formations accréditées et sur mesure. Brisez les barrières,
            obtenez votre diplôme avec succès.
          </p>
          <div className="welcome-actions">
            <a href="#free-courses" className="welcome-btn-primary">Explorer les cours</a>
            <a href="#about" className="welcome-btn-secondary">Découvrir plus</a>
          </div>
        </div>
      </div>
      
      <div className="welcome-images">
        <div className="image-card top-image tilt-right">
          <img
            src={RoundedImage1}
            alt="Professeur et étudiant"
            className="hero-image"
          />
        </div>
        <div className="image-card bottom-image tilt-left">
          <img
            src={RoundedImage2}
            alt="Enseignante avec élève"
            className="hero-image"
          />
        </div>
      </div>
    </div>
  );
};

export default Welcome;